import _ from 'lodash';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { filter, skipWhile } from 'rxjs/operators';
import { InitiateVerifyEmail, LoadUser, SignUp } from '../../features/data/data.actions';
import { selectUser, selectUserError } from '../../features/data/data.selectors';
import { PasswordLevelValidator } from '../../validators/password-level.validator';
import { PasswordValidator } from '../../validators/password.validator';
import { ERRORS } from 'app/virtual-event/virtual-event.enums';
import * as DialogActions from 'app/dialog/features/dialog.actions';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-signup01',
  templateUrl: './signup01.component.html',
  styleUrls: ['./signup01.component.scss']
})
export class Signup01Component implements OnInit {
  destroyRef = inject(DestroyRef)
  public error$ = this.store.pipe(
    select(selectUserError)
  );

  public user$ = this.store.pipe(
    select(selectUser)
  );

  public form: UntypedFormGroup = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    organization: new UntypedFormControl('', [Validators.required]),
    password: new UntypedFormControl('', [Validators.required, PasswordLevelValidator()]),
    repeatPassword: new UntypedFormControl('', [Validators.required]),
    terms: new UntypedFormControl(false, [Validators.requiredTrue])
  }, { validators: [PasswordValidator] });
  public submitted: boolean = false;

  public notVerifiedError = false;

  constructor(
    private store: Store,
  ) { }

  ngOnInit(): void {
    this.error$.pipe(
      filter(error => !_.isNull(error)),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.form.get('email').setErrors({ unique: true });
    });

    this.user$.pipe(
      skipWhile(() => _.isEqual(this.submitted, false)),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(user => {
      const emailVerified = _.get(user, 'emailVerified', false);
      if(emailVerified === false) {
        this.notVerifiedError = true;
      }
    });
  }

  onNext(): void {
    const { form } = this;
    form.markAllAsTouched();
    var self = this;
    const repeatPassword = form.get('repeatPassword');
    if(form.hasError('password')) {
      repeatPassword.setErrors({ password: true });
    }

    if(form.valid) {
      if(window['isProduction']) {
        return window['grecaptcha'].ready(function () {
          window['grecaptcha'].execute('6Lcy_6YUAAAAAALMoCCdzR4b7nJBxNeoaEl3LQQf', {
            action: "pay"
          }).then(function (reCAPTCHAToken) {
            self.store.dispatch({
              type: SignUp.type,
              payload: {
                email: form.get('email').value,
                password: form.get('password').value,
                name: form.get('organization').value,
                reCAPTCHAToken
              }
            });
          })
        })
      } else {
        this.store.dispatch({
          type: SignUp.type,
          payload: {
            email: form.get('email').value,
            password: form.get('password').value,
            name: form.get('organization').value,
            reCAPTCHAToken: null
          }
        });
      }   
    }
  }

  onResend(): void {
    this.store.dispatch({
      type: InitiateVerifyEmail.type
    });
  }

  onChangeEmail(): void {
    const action = DialogActions.openDialog({
      payload: {
        name: "ChangeEMail",
        options: {
          size: 'default',
          modalClass:'modal--paybee',
          containerClass:'mdb-modal-backdrop-paybee'
        },
      }
    });
    this.store.dispatch(action);
  }

  onUpdateUser(): void {
    this.submitted = true;
    this.store.dispatch({
      type: LoadUser.type
    });
  }

  onLogin(): void {
    window.location.href = '/org.html';
  }

  onLogout(): void {
    window['orgSignUp'].doLogout();
  }

  getUserErrorMessage() {
    const { form } = this;
    const email = form.get('email');

    if(!email.touched) return '';

    if(email.hasError('required')) {
      return 'Please provide valid email id';
    }

    if(email.hasError('unique')) {
      return ERRORS.UserAlreadyExist;
    }

    return '';
  }

  getPasswordErrorMessage() {
    const { form } = this;

    const password = form.get('password');
    if(password.hasError('required')) {
      return 'Please provide Password';
    }
    if(password.hasError('weak')) {
      return 'Weak password, please add numbers or special characters to it';
    }
    return '';
  }

  getTermsErrorMessage() {
    const { form } = this;
    const terms = form.get('terms');

    if(!terms.touched) return '';

    if(terms.hasError('required')) {
      return 'Please Accept PayBee\'s TOS';
    }

    return '';
  }
}
